import styled from "styled-components";
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";
import DatepickerRange from "../molecules/DatepickerRange";
import { useQuery } from "@tanstack/react-query";
import Loading from "./Loading";
import {useState} from "react";
import DataTable from "../organisms/DataTable";
import axios from "axios";
import { Col, Form, Row, Button } from "react-bootstrap";
import TableFilterBox from "../organisms/TableFilterBox";

const TableWrap = styled.div`
    flex: 1 1;
    display: flex;
    flex-direction: column;

    .data-table {
        flex-grow: 1;
    }

    .total-badge {
        background: #ffd700;
        color: #000;
        padding: 6px 12px;
        border-radius: 15px;
        font-weight: bold;
        font-size: 1.1em;
        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        text-transform: uppercase;
        letter-spacing: 1px;
    }
`;

const SettlementCount = () => {
  const defaultDate = moment().format("YYYY-MM-DD");
  const defaultFilter = {
    startDate: defaultDate,
    endDate: defaultDate
  }
  const {companyId, branchId} = useParams();
  const [filter, setFilter] = useState(defaultFilter);
  const [settlementData, setSettlementData] = useState({
    head: [
      "지점", "유료 건수(워크리스트)", "유료 건수(자체생성)", "유료 건수(전체)", "무료 건수", "전체 건수"
    ],
    body: [],
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['settlementCount', filter],
    queryFn: async () => {
      try {
        const response = await axios.post('/settlement/count', {
          startDate: filter.startDate,
          endDate: filter.endDate,
          branchId: !branchId || branchId === "0" ? null : branchId,
          companyId: companyId ? companyId : null,
        });

        const formattedData = response.data.data.map(item => [
          item.branch_name === '총계' ? 
            <span className="total-badge">{item.branch_name}</span> : 
            item.branch_name || '-',
          item.premium_worklist_count || '0',
          item.premium_non_worklist_count || '0',
          item.total_premium_count || '0',
          item.free_count || '0',
          item.total_count || '0'
        ]);

        setSettlementData(prev => ({
          ...prev,
          body: formattedData
        }));
   
        return response.data;

      } catch (error) {
        throw new Error(error.response?.data?.msg?.ko || '데이터를 가져오는데 실패했습니다');
      }
    },
    refetchInterval: 60000
  });

  const downloadCSV = () => {
    const csvContent = [
      settlementData.head.join(','),
      ...settlementData.body.map(row => row.map(cell => typeof cell === 'object' ? cell.props.children : cell).join(','))
    ].join('\n');

    // Add BOM for Windows Excel to properly recognize UTF-8 Korean characters
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `settlement_count_${moment().format('YYYYMMDD_HHmmss')}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  if (isLoading) return <Loading />;

  if (isError) {
    if (error.response) {
      return <div>{error.response.data.msg.ko}</div>
    }
    return <div>{error.message}</div>
  }

  return (
    <TableWrap>
      <TableFilterBox
        handleClickReset={() => {
          setFilter(defaultFilter);
        }}
        handleClickSubmit={() => {
          refetch();
        }}
      >
        <Row className="mt-4 justify-content-between">
          <Col sm={6} xxl={5}>
            <Form.Group as={Row}>
              <Form.Label column sm={2} xxl={3}>
                측정일
              </Form.Label>
              <Col sm={10} xxl={9}>
                <DatepickerRange 
                  startDate={filter.startDate}
                  endDate={filter.endDate}
                  onChange={(dates) => {
                    setFilter(prev => ({
                      ...prev, 
                      startDate: dates[0],
                      endDate: dates[1]
                    }));
                  }}
                />
              </Col>
            </Form.Group>
          </Col>
          <Col sm={6} xxl={5} className="text-end">
            <Button onClick={downloadCSV}>CSV 다운로드</Button>
          </Col>
        </Row>
      </TableFilterBox>

      <DataTable 
        isError={isError}
        isLoading={isLoading}
        data={settlementData}
      />
    </TableWrap>
  );
}

export default SettlementCount;